import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";

/** モジュール */
// ルーティング
import { AppRoutingModule } from "./app-routing.module";

// 共通モジュール
import { PagesModule } from "./pages/pages.module";
import { SharedModule } from "./shared/shared.module";

/** 定数 */
import { TEST_DOMAIN, PROD_DOMAIN, STAGING_DOMAIN, DEMO_DOMAIN, TRIAL_DOMAIN } from "manager/environment";

/** コンポーネント */
import { AppComponent } from "./app.component";

/** サービス */
import {
  AuthInterceptor,
  ErrorInterceptor,
} from "src/app/shared/service/interceptor.service";

/** ngx-translate */
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

/** ngx-page-scroll */
import { NgxPageScrollCoreModule } from "ngx-page-scroll-core";
import { NgxPageScrollModule } from "ngx-page-scroll";

import {
  CLOSE_LOGIC1_DEV_DOMAIN,
  CLOSE_LOGIC2_DEV_DOMAIN,
  CLOSE_LOGIC1_TEST_DOMAIN,
  CLOSE_LOGIC2_TEST_DOMAIN,
  CLOSE_LOGIC1_STAGING_DOMAIN,
  CLOSE_LOGIC2_STAGING_DOMAIN,
  CLOSE_LOGIC1_PROD_DOMAIN,
  CLOSE_LOGIC2_PROD_DOMAIN,
  CLOSE_LOGIC1_DEMO_DOMAIN,
  CLOSE_LOGIC2_DEMO_DOMAIN,
  CLOSE_LOGIC1_TRIAL_DOMAIN,
  CLOSE_LOGIC2_TRIAL_DOMAIN
} from "../../manager/environment";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    PagesModule,
    SharedModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function getAuthenticateRequiredUrls() {
  const allowUrls = [
    CLOSE_LOGIC1_DEV_DOMAIN,
    CLOSE_LOGIC2_DEV_DOMAIN,
    CLOSE_LOGIC1_TEST_DOMAIN,
    CLOSE_LOGIC2_TEST_DOMAIN,
    CLOSE_LOGIC1_STAGING_DOMAIN,
    CLOSE_LOGIC2_STAGING_DOMAIN,
    CLOSE_LOGIC1_PROD_DOMAIN,
    CLOSE_LOGIC2_PROD_DOMAIN,
    CLOSE_LOGIC1_DEMO_DOMAIN,
    CLOSE_LOGIC2_DEMO_DOMAIN,
    CLOSE_LOGIC1_TRIAL_DOMAIN,
    CLOSE_LOGIC2_TRIAL_DOMAIN,
  ];
  
}
